// components/home/listings/hotel/SearchBar.jsx — matches services page toolbar
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './css/SearchBar.css';

const SearchBar = ({
    onSearch,
    onFilterClick,
    searchTerm: externalSearchTerm = '',
    activeFilterCount = 0,
    placeholder,
    filterLabel
}) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState(externalSearchTerm);
    const onSearchRef = useRef(onSearch);
    const skipFirstRunRef = useRef(true);
    onSearchRef.current = onSearch;

    const resolvedPlaceholder = placeholder || t('hotel_page.search_placeholder');
    const resolvedFilterLabel = filterLabel || t('hotel_page.filters');

    // Sync when parent resets (e.g. Clear all filters)
    useEffect(() => {
        setSearchTerm(externalSearchTerm);
    }, [externalSearchTerm]);

    // Auto-search on keystroke — debounce 300ms (skip first run)
    useEffect(() => {
        if (skipFirstRunRef.current) {
            skipFirstRunRef.current = false;
            return undefined;
        }
        const timer = setTimeout(() => {
            onSearchRef.current(searchTerm.trim());
        }, 300);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const handleClear = () => {
        setSearchTerm('');
        onSearchRef.current('');
    };

    return (
        <div className="sf-toolbar">
            <div className="sf-toolbar-search">
                <i className="fa fa-search sf-toolbar-search-icon" aria-hidden="true" />
                <input
                    type="text"
                    className="sf-toolbar-input"
                    placeholder={resolvedPlaceholder}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    aria-label={resolvedPlaceholder}
                />
                {searchTerm && (
                    <button className="sf-toolbar-clear" onClick={handleClear} aria-label="Clear search">
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                )}
            </div>
            <div className="sf-toolbar-actions">
                <button className="sf-toolbar-filter-btn" onClick={onFilterClick}>
                    <i className="fas fa-sliders-h" aria-hidden="true" />
                    <span className="sf-toolbar-filter-label">{resolvedFilterLabel}</span>
                    {activeFilterCount > 0 && (
                        <span className="sf-toolbar-filter-count">{activeFilterCount}</span>
                    )}
                </button>
            </div>
        </div>
    );
};

export default SearchBar;
